import { Injectable } from '@angular/core';
import { OGKushPrintCardContentViewModel } from '../../content-view-models/og-kush-print-card-content-view-model';

@Injectable()
export class OGKushIndexCardStackContentViewModel extends OGKushPrintCardContentViewModel {}
